import React from 'react';
import { EmptyContent } from '../../../../../components/common';
import { EmptyLayoutWrapper } from './empty-layout-wrapper';

export const EmptyDataList: React.FC = (): React.ReactElement => {
    return (
        <EmptyLayoutWrapper>
            <EmptyContent
                text="No data available"
                imgUrl="https://assets.prizeout.com/partner-portal/no-data.svg"
                hasButton={false}
                title={null}
            />
        </EmptyLayoutWrapper>
    );
};
